
import React, { useState } from 'react';
import { ClipboardDocumentIcon } from '@heroicons/react/24/outline';
import { CheckIcon } from '@heroicons/react/24/outline';
import { translations } from '../../../utils/translations/translations-manager';
import { CentsPalette } from '../../../utils/colors';

export function CopyableLabel({ prefix, text, className, iconClassName, textClassName }: { prefix?: string, text: string, className?: string, iconClassName?: string, textClassName?: string }): JSX.Element {
  const [copied, setCopied] = useState(false);
  const copyToClipboard = () => {
    navigator.clipboard.writeText(text);
    setCopied(true);
    setTimeout(() => setCopied(false), 1000)
  };

  return (
    <div className='relative transition duration-300 flex items-center pointer-events-auto'>
      <div className={'w-fit max-w-full flex flex-row items-center rounded-lg h-6 px-2 text-blue-700 hover:text-cents-white hover:bg-cents-purple group'.concat(className ? ` ${className}` : '')} onClick={copyToClipboard}>
        {copied ? (
          <div className='max-w-full flex flex-row justify-start items-center text-sm truncate overflow-hidden'>
            <CheckIcon className='flex-none h-4 w-4 mr-2 group-hover:stroke-cents-white group-hover:stroke-[2px]' strokeWidth={3} stroke={CentsPalette.cents_purple} />
            <span className='truncate overflow-hidden text-xs font-bold text-cents-purple group-hover:font-medium group-hover:text-cents-white'>{translations.texts.copied.toString()}</span>
          </div>
        ) : (
          <div className={'max-w-full flex flex-row justify-start items-center cursor-pointer'}>
            <ClipboardDocumentIcon className={'flex-none h-4 w-4 mr-2'.concat(iconClassName ? ` ${iconClassName}` : '')} />
            <span className={'truncate overflow-hidden underline'.concat(textClassName ? ` ${textClassName}` : '')}>{(prefix ?? '') + text}</span>
          </div>
        )}
      </div>
    </div >
  );
};

export default CopyableLabel;